import type { GridCell } from '@glideapps/glide-data-grid';

import { COLUMN_IDS } from '../constants';

import { isTickerCell } from '../../CustomCell/Ticker';
import {
  isSharePriceCell,
  getSharePriceCellTemplate,
} from '../../CustomCell/SharePrice';
import {
  isTotalCostCell,
  getTotalCostCellTemplate,
} from '../../CustomCell/TotalCost';

const priceColIndex = COLUMN_IDS.indexOf('price');
const totalCostColIndex = COLUMN_IDS.indexOf('cost');

export const updateRowCurrencyISO = (row: (GridCell | undefined)[]) => {
  if (row.length !== COLUMN_IDS.length) return row;

  const tickerCell = row.filter(isTickerCell)[0];

  if (!tickerCell) return row;

  const currencyISO = tickerCell.data.currencyISO;

  return row.map((cell, colIndex) => {
    if (colIndex === priceColIndex) {
      if (typeof cell === 'undefined') {
        return {
          ...getSharePriceCellTemplate({ currencyISO }),
        };
      } else if (isSharePriceCell(cell)) {
        cell.data.currencyISO = currencyISO;
      }
    }

    if (colIndex === totalCostColIndex) {
      if (typeof cell === 'undefined') {
        return {
          ...getTotalCostCellTemplate({ currencyISO }),
        };
      } else if (isTotalCostCell(cell)) {
        cell.data.currencyISO = currencyISO;
      }
    }

    return cell;
  });
};
